import Tabs from "@/components/Tabs";
import useCapabilities, { DOMAIN } from "@/hooks/useCapabilities";
import { useFlags } from "@/hooks/useFeatureFlags";
import AppLayout from "@/layouts/AppLayout";
import PageHeading from "@/components/PageHeading";
import { Path, useNavigate } from "@/router";
import { useLocation } from "react-router-dom";

export default function TabLayout({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const { pathname } = location;
  const navigate = useNavigate();
  const flags = useFlags();
  const { capabilities } = useCapabilities();

  const showFinanceTab = !!flags["backoffice-grp"] && capabilities.domains.includes(DOMAIN.BENEFIT_PROGRAMS);

  const tabItems: { label: string; to: Path }[] = [
    {
      label: "Orders",
      to: "/billing/orders"
    },
    {
      label: "Payments",
      to: "/billing/payments"
    },
    {
      label: "Dues Management",
      to: "/billing/dues-management"
    },
    {
      label: "Payout Profiles",
      to: "/billing/payout-profiles"
    },
    ...(showFinanceTab
      ? [
          {
            label: "Finance",
            to: "/billing/finance" as Path
          }
        ]
      : [])
  ];

  return (
    <AppLayout>
      <PageHeading title="Billing" />
      <Tabs
        tabItems={tabItems.map(({ label, to }) => ({
          label,
          onClick: () => navigate(to),
          active: (pathname.endsWith("/") ? pathname.slice(0, -1) : pathname) === to
        }))}
      />
      <div className="flex flex-col">{children}</div>
    </AppLayout>
  );
}
